import { createClient } from '@supabase/supabase-js'
import { SUPABASE_CONFIG, validateConfig } from './config/supabaseConfig'

// 🔥 CONFIGURAÇÃO SUPABASE
// Usar configurações do arquivo de configuração primeiro, depois env, depois fallback
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || SUPABASE_CONFIG.url
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || SUPABASE_CONFIG.anonKey

// Validar configurações
const configValid = validateConfig();
console.log('🔧 Status das configurações:', configValid ? '✅ Válidas' : '❌ Inválidas');

// Debug das configurações
console.log('🔧 Configurações Supabase:', {
  url: supabaseUrl,
  keyLength: supabaseAnonKey?.length || 0,
  hasUrl: !!supabaseUrl,
  hasKey: !!supabaseAnonKey,
  fromEnv: !!process.env.REACT_APP_SUPABASE_URL,
  fromConfig: !process.env.REACT_APP_SUPABASE_URL
})

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  realtime: {
    params: {
      eventsPerSecond: 10 // Otimização para evitar excesso de chamadas
    }
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web'
    },
    fetch: (url, options = {}) => {
      // Adicionar timeout de 30 segundos
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);
      
      return fetch(url, {
        ...options,
        signal: controller.signal
      }).finally(() => clearTimeout(timeoutId));
    }
  }
})

console.log('✅ Cliente Supabase inicializado')

// 🛡️ HELPER FUNCTIONS
export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) throw error
  return user
}

export const signOut = async () => {
  const { error } = await supabase.auth.signOut()
  if (error) throw error
}

// 📊 CONSTANTS
export const TABLES = {
  USERS: 'users',
  POSTS: 'posts', 
  COMMENTS: 'comments',
  MESSAGES: 'messages',
  CHATS: 'chats',
  LIKES: 'likes',
  FRIENDS: 'friendships'
}

export default supabase